import { useCallback, useState } from 'react';
import { vehicleCheckAPI, vehicleCompareAPI } from '../../api/vehicleCheck';

// 차량 확인 상태 — 물품 설명·사진·결과 + 차량별 예상 운임(접수 폼에 출발·도착이 있을 때). 모달이 닫혀도 마지막 결과는 남겨 다시 열면 보인다.
// getContext() 는 접수 폼의 출발·도착·편도/왕복·급송 스냅샷을 돌려준다(회원 전용 기능이라 호출 쪽이 로그인 뒤에만 연다)
export const MAX_IMAGES = 3;

export default function useVehicleCheck({ getContext } = {}) {
  const [text, setText] = useState('');
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [compare, setCompare] = useState(null);       // { rows:[{vehicle,total,payable,discount}], travel:{km,min,source}|null }
  const [compareBusy, setCompareBusy] = useState(false);

  const context = getContext ? getContext() : null;
  const hasRoute = Boolean(context && context.startAddr && context.endAddr);

  const addFiles = useCallback((list) => {
    const images = Array.from(list || []).filter((f) => /^image\//.test(f.type));
    setFiles((prev) => [...prev, ...images].slice(0, MAX_IMAGES).map((f) => (f.preview ? f : Object.assign(f, { preview: URL.createObjectURL(f) }))));
  }, []);
  const removeFile = useCallback((index) => setFiles((prev) => prev.filter((_, i) => i !== index)), []);

  // 추천·대안 차량 + 기본 사다리(서버가 더한다)의 예상 운임과 길찾기 거리·시간
  const runCompare = useCallback(async (res) => {
    const ctx = getContext ? getContext() : null;
    if (!ctx || !ctx.startAddr || !ctx.endAddr) { setCompare(null); return; }
    setCompareBusy(true);
    const vehicles = [res.vehicle, ...(res.alternatives || []).map((a) => a.vehicle)].filter(Boolean);
    const resp = await vehicleCompareAPI({ ...ctx, vehicles });
    setCompareBusy(false);
    setCompare(resp && resp.status === 200 ? resp.data : null);
  }, [getContext]);

  const run = useCallback(async () => {
    if (busy || (!text.trim() && !files.length)) return;
    setBusy(true); setError(''); setResult(null); setCompare(null);
    const resp = await vehicleCheckAPI(text, files);
    setBusy(false);
    if (!resp || resp.status !== 200) { setError((resp && resp.data && resp.data.message) || '확인에 실패했습니다. 잠시 후 다시 시도해 주세요.'); return; }
    setResult(resp.data.result);
    runCompare(resp.data.result);
  }, [busy, text, files, runCompare]);

  const reset = useCallback(() => { setText(''); setFiles([]); setResult(null); setCompare(null); setError(''); }, []);

  return {
    text, setText, files, addFiles, removeFile, busy, result, error, run, reset,
    compare, compareBusy, hasRoute,
    canRun: Boolean(text.trim() || files.length) && !busy,
  };
}
